import Hero from './components/Hero';
import About from './components/About';
import Experience from './components/Experience';
import Education from './components/Education';
import Skills from './components/Skills';
import Projects from './components/Projects';
import Languages from './components/Languages';
import Achievements from './components/Achievements';
import Contact from './components/Contact';
import Signature from './components/Signature';
import './App.css';
import { ToastContainer } from 'react-toastify';

function App() {
  return (
    <div className="App">
      <Hero />
      <About />
      <Experience />
      <Education />
      <Skills />
      <Projects />
      <Languages />
      <Achievements />
      <Contact />
      <Signature />
      <ToastContainer />
    </div>
  );
}

export default App;
